import * as moment from 'moment';
import { isNil } from 'lodash';

export const DATE_FORMAT = 'll';
export const DATE_TIME_FORMAT = 'lll';

export const formatters = {
       
    formatBoolean(value: boolean): string {
        return isNil(value)
            ? ''
            : value ? 'Yes' : 'No';
    },

    formatDate(value: moment.Moment): string {
        return moment.isMoment(value) && value.isValid() ? value.format(DATE_FORMAT) : '';
    },

    formatDateTime(value: moment.Moment): string {
        return moment.isMoment(value) && value.isValid() ? value.format(DATE_TIME_FORMAT) : '';
    }
};